// extracted by mini-css-extract-plugin
module.exports = {"import_component":"externekoppeling-import_import_component__3WZo9"};